import { useUserTaskQuery } from '@/client/graphql/tasks.generated';
import { TaskRuleAction, TaskRuleTimePeriod } from '@/client/graphql/types.generated';
import { useCurrentUser } from '@/utils/hooks/useCurrentUser';
import { Container, Flex } from '@chakra-ui/react';
import useTranslation from 'next-translate/useTranslation';
import { UserRewardsLevel } from '../rewards.types';
import { TilesOverview } from '../tiles-overview/tiles-overview';
import { formatTilesFromRewards } from '../tiles-overview/tiles-overview.helpers';
import { ClaimRewardTileProps } from '../tiles-overview/tiles-overview.types';

const RewardsSection = (props: UserRewardsLevel) => {
  const currentUser = useCurrentUser();
  const { t } = useTranslation('common');
  const [{ data: registerTaskData }] = useUserTaskQuery({
    variables: {
      rules: {
        timePeriod: TaskRuleTimePeriod.OneTime,
        action: TaskRuleAction.Register,
      },
    },
  });

  const claimRewardTitle: ClaimRewardTileProps[] = [
    {
      title: `${registerTaskData?.getTask.points || 0}`,
      subtitle: t('labels.experience-points'),
    },
  ];

  return (
    <Container as="section" position="relative">
      <Flex direction={{ base: 'column', md: 'row' }}>
        {/* <Flex direction="column" flexBasis={{ base: '100%', md: '25%' }}>
          <LevelIndicator
            level={props.level}
            title={props.title}
            minimumXP={props.minimumXP}
            maximumXP={props.maximumXP}
            currentXP={currentUser.xp}
          />
        </Flex> */}
        <Flex direction="column" flexBasis={{ base: '100%' }} mb={{ base: '2xl', md: '144px' }}>
          <TilesOverview
            items={[...claimRewardTitle, ...formatTilesFromRewards(props.clubs)].filter(Boolean)}
          />
        </Flex>
      </Flex>
    </Container>
  );
};

export default RewardsSection;
